module.exports = __webpack_public_path__ + "img/production-default.324004c1.svg";